<template>
    <div>
        <common-table :form-fields="formFields"
                      :table-columns="tableColumns"
                      :url="url"
                      :searchs="searchs"
                      :permission="permission"
                      :operate="operate"
                      ref="table"
        />

    </div>
</template>

<script>
    import CommonTable from "../../components/CommonTable/CommonTable";
    export default {
        name: "QuantificationRecord",
        components: {CommonTable},
        data() {
            return {

                searchs: [{
                    name: 'agentId',
                    placeholder: '代理',
                    type: 'select',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                } ,{
                  name: 'phone',
                  placeholder: '手机号',
                  type: 'input'
                },],
                permission:{
                    // add: 'quantificationRecord:add',
                    // update: 'quantificationRecord:update',
                    // delete: 'quantificationRecord:delete',
                    // deleteBatch: 'quantificationRecord:deleteBatch'
                },
                url: {
                    get: '/quantificationRecord/listByCondition',
                    // add: '/quantificationRecord/add',
                    // update: '/quantificationRecord/update',
                    // delete: '/quantificationRecord/delete/',
                    // delete_batch: '/quantificationRecord/deleteBatch',
                    // status: '/quantificationRecord/update'
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '100',
                }, {
                  field: 'agentId',
                  label: '代理',
                  selectUrl: '/agent/getAll',
                  selectData: [],
                  show: {
                    type: 'select',
                  },
                  detail: false,
                  width: '',
                },{
                  field: 'phone',
                  label: '手机号',
                  show: true,
                  width: '',
                }, {
                    field: 'ratio',
                    label: '提/充比',
                    show: {
                        type: 'thousandthsRatio'
                    },
                    width: '',
                }, {
                  field: 'createTime',
                  label: '创建时间',
                  show: true,
                  width: '',
                }],
                formFields: {
                    addTitle: '添加代理',
                    updateTitle: '修改代理',
                    labelWidth: '100px',
                    toTree: false,
                    model: [{
                      field: 'agentId',
                      label: '代理：',
                      type: 'select',
                      placeholder: '请选择代理',
                      rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
                      selectUrl: '/agent/getAll',
                      selectData: [],
                      add: true,
                      update: true,
                      filterable: true,
                    },  {
                        field: 'ratio',
                        label: '充提比',
                        type: 'money',
                        placeholder: '充提比(%)',
                        rules: [{
                            message: '请输入充提比', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'text',
                        label: '弹窗内容',
                        type: 'editor',
                        placeholder: '弹窗内容',
                        rules:[{
                            message: '请输入弹窗内容', trigger: 'blur', required: false
                        }],
                        add: true,
                        update: true,
                        default: 0
                    }]
                },
                operate: []
            }
        },
        methods: { },
    }
</script>

<style scoped>
    .domain {
        max-width: 350px;
    }
</style>
